<div class="detaljer">
  <entitetikon type="Beslutning" stoerrelse="20px"/>
  <span class="favoritt">
    @if (erFavoritt()) {
      <mat-icon fontSet="ion-ios-star" class="mat-icon--ionic-ikon"/>
    }
  </span>
  <span class="tittel" data-testid="beslutning-tittel" #tittelFelt>
    @if (harTittel()) {
      {{ tittel() }}
    } @else {
      <html-formatert [innhold]="beskrivelse()"/>
    }
  </span>
  <span class="meny">
    <button mat-icon-button
            [matMenuTriggerFor]="beslutningMeny"
            (click)="$event.stopPropagation()"
            [disabled]="menyDeaktivert()"
            class="mat-medium-icon-button"
            data-testid="beslutning-meny">
      <mat-icon class="material-symbols-fet">more_vert</mat-icon>
    </button>
    <mat-menu #beslutningMeny="matMenu">
      @if (redigeringMulig()) {
        <button mat-menu-item (click)="rediger()">
          <mat-icon>edit</mat-icon>
          {{ 'Rediger'|translate }}
        </button>
        <button mat-menu-item [bekreftKlikk]="'Ja, slett beslutningen'|translate" (klikk)="slett()">
          <mat-icon fontSet="ion-ios-trash" class="mat-icon--ionic-ikon"/>
          {{ 'Slett'|translate }}
        </button>
        <mat-divider/>
        <button mat-menu-item (click)="nyOppgave()">
          <mat-icon fontSet="lederplan-ikon-oppgave" class="mat-icon--lederplan-ikon"/>
          {{ 'Ny oppgave'|translate }}
        </button>
      }
      <button mat-menu-item (click)="endreFavorittmarkering()">
        <mat-icon fontSet="ion-ios-star-outline" class="mat-icon--ionic-ikon"/>
        @if (erFavoritt()) {
          {{ 'Fjern fra favorittlisten'|translate }}
        } @else {
          {{ 'Legg til i favorittlisten'|translate }}
        }
      </button>
    </mat-menu>
  </span>
</div>
@if(harTittel() && harBeskrivelse()){
<div class="beskrivelse" data-testid="beslutning-beskrivelse">
  <html-formatert [innhold]="beskrivelse()"/>
</div>
}
<liste-lenkerelasjoner [lenker]="beslutning().referertFra"/>
<oppgaveliste-kompakt [oppgaver]="oppgaver()"/>
